import clone from 'clone';

import {
    CLEAR_REFERRAL_CODE,
    FETCH_REFERRAL_CODES, FETCH_REFERRAL_CODES_SUCCESS, FETCH_REFERRAL_CODES_FAILURE,
    SAVE_REFERRAL_CODE, SAVE_REFERRAL_CODE_SUCCESS, SAVE_REFERRAL_CODE_FAILURE,
    EMPTY_REFERRAL_CODES, SET_REFERRAL_CODE, SET_REFERRAL_CODES
} from './constants';

const initialState = {
    all: [],
    allMetadata: {page: 0},
    referralCode: {},
    isFetching: false,
    isSaving: false,
    error: {},
    saveError: {}
};

function referralCodesReducer(state = initialState, action) {
    switch(action.type) {
        case CLEAR_REFERRAL_CODE:
            return Object.assign({}, state, {
                referralCode: {}
            });
        case EMPTY_REFERRAL_CODES:
            return initialState;
        case FETCH_REFERRAL_CODES:
            return Object.assign({}, state, {
                isFetching: action.hideSpinner !== true,
                error: {}
            });
        case FETCH_REFERRAL_CODES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                all: action.data,
                allMetadata: action.meta
            });
        case FETCH_REFERRAL_CODES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SAVE_REFERRAL_CODE:
            return Object.assign({}, state, {
                isSaving: true,
                saveError: {}
            });
        case SAVE_REFERRAL_CODE_SUCCESS:
            let newAll = clone(state.all);
            for(var i = 0; i < newAll.length; i++) {
                if(newAll[i].id === action.data.id) {
                    newAll[i] = action.data;
                    break;
                }
            }
            return Object.assign({}, state, {
                isSaving: false,
                referralCode: {},
                all: newAll
            });
        case SAVE_REFERRAL_CODE_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                saveError: action.error
            });
        case SET_REFERRAL_CODE:
            return Object.assign({}, state, {
                referralCode: action.data
            });
        case SET_REFERRAL_CODES:
            return Object.assign({}, state, {
                all: action.data
            });
        default:
            return state;
    }
}

export default referralCodesReducer;



// WEBPACK FOOTER //
// ./src/containers/ReferralCodesPage/store/reducers.js